<template>
  <div>
    <RouterLink
      v-for="visit in visits"
      :key="visit.id"
      :to="{
        name: 'Stats/Detail',
        params: { id: visit.id },
      }"
      class="m-reset-link"
    >
      <ListItemVisit
        :branchGetter="branchGetter"
        :visit="visit"
      />
    </RouterLink>
  </div>
</template>

<script setup>
import ListItemVisit from '@/components/ListItemVisit.vue';

defineProps({
  visits: {
    type: Array,
    required: true,
  },
  branchGetter: {
    type: Function,
    required: true,
  },
});

</script>
